import FormattedMessage from 'I18n/components/FormattedMessage';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { useFilterValues } from 'find-and-filter-data/search-and-filter-data/public';
import { getHideFiltered } from 'find-and-filter-data/search-and-filter-schema/protected';
import { jsx as _jsx } from "react/jsx-runtime";
const FilteredToggle = () => {
  const {
    filterValues,
    setFilterValue
  } = useFilterValues();
  const onChange = ({
    target: {
      checked
    }
  }) => {
    setFilterValue('hideFiltered', checked);
  };
  return /*#__PURE__*/_jsx(Checkbox, {
    checked: getHideFiltered(filterValues),
    onChange: onChange,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.filtered.title"
    })
  });
};
FilteredToggle.displayName = 'FilteredToggle';
export default FilteredToggle;